import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// @material-ui/icons
import { makeStyles } from "@material-ui/core/styles";

import { useHistory, useParams } from "react-router-dom";

//@material-ui/tab
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import MobileWrapper from "componentsCustom/Mobile/MobileWrapper.js";

import menuStyle from "assets/jss/material-dashboard-pro-react/views/menuStyle.js";

import LeftSideMuseumInfoTickets from "../componentsCustom/Museum/LeftSideMuseumInfoTickets";
import styles from "./EventList.module.css";
import NavBarEvent from "../componentsCustom/EventList/NavBarEvent";
import Tickets from "./Tickets";
import Events from "./Events";

const useStyles = makeStyles(menuStyle);

export default function BaseEventList(props) {
  const {
    updateCart,
    cart,
    language,
    museum,
    currency,
    customStyle,
    events,
    shippingInfo,
    cartParams,
    articles,
    updateEventSelected,
    eventSelected,
  } = props;

  const history = useHistory();

  const { home } = useParams();

  const [isEvents, setIsEvents] = useState(false);
  const [isTickets, setIsTickets] = useState(false);

  const [tabIndex, setTabIndex] = useState(0);

  const classes = useStyles();

  const { t } = useTranslation();

  const {
    cartCounter,
    totToShow, // totalPrice + servicesFees + deliveryCost
  } = cartParams;

  const selected = (index) => {
    return index === 0 ? (
      <Tickets
        updateCart={updateCart}
        cart={cart}
        language={language}
        museum={museum}
        currency={currency}
        customStyle={customStyle}
        shippingInfo={shippingInfo}
        articles={articles}
        eventSelected={eventSelected}
        updateShippingInfo={props.updateShippingInfo}
        updateCartParams={props.updateCartParams}
        cartParams={cartParams}
      />
    ) : (
      <Events
        updateCart={updateCart}
        cart={cart}
        museum={museum}
        currency={currency}
        customStyle={customStyle}
        cartParams={cartParams}
        updateEventSelected={updateEventSelected}
        events={events}
        windowSize={windowSize}
      />
    );
  };

  const [windowSize, setWindowSize] = useState(getWindowSize());

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  useEffect(() => {
    if (home === "events") {
      setIsEvents(true);
      setIsTickets(false);
      setTabIndex(1);
    } else if (home === "tickets") {
      setIsEvents(false);
      setIsTickets(true);
      setTabIndex(0);
    } else {
      setIsEvents(false);
      setIsTickets(false);
    }
  }, [home]);

  return (
    <div
      style={{
        backgroundColor: museum?.customizations?.eventDetailsBgColor
          ? museum?.customizations?.eventDetailsBgColor
          : "#ffffff",
      }}
    >
      <style>
        {`.MuiPickersToolbar-toolbar, .MuiPickersDay-daySelected {
          background-color: ${
            museum?.customizations?.museumInfoBgColor
              ? museum?.customizations?.museumInfoBgColor
              : "#000"
          } !important
        }`}
      </style>
      <MobileWrapper
        type={"contacts"}
        showButtons={!!(cartCounter && cartCounter > 0)}
        containerClasses={classes.eventListContainer}
        containerMobileButton={classes.containerMobileButtonMenu}
        buttons={[
          {
            // l'errore potrebbe essere qui, visto che desktop funziona
            onClick: () => {
              history.push(`/${museum.identificativo}/contacts/${home}`);
            },
            color: "warning",
            text: t("cart.go_to_cart"),
            isActive: true,
            isLinkActive: true,
            path: `../contacts`,
            customStyle: { backgroundColor: customStyle.buttonCart },
            leftComponent: (
              <>
                {cartCounter ? (
                  <span style={{ verticalAlign: "super" }}>
                    <span className={classes.notifications}>
                      <span>{cartCounter}</span>
                    </span>
                  </span>
                ) : null}
              </>
            ),
            rightComponent: (
              <span className={classes.littlePrice}>
                {totToShow ? totToShow.toFixed(2) : ""}
                <span style={{ paddingRight: "2px", color: "white" }}>
                  {totToShow && currency && currency.symbol
                    ? currency.symbol
                    : ""}
                </span>
              </span>
            ),
          },
        ]}
      >
        <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            backgroundColor: museum?.colore || "#303030",
          }}
        >
          <NavBarEvent
            logoUrl={museum?.logo_light?.url}
            bgColor={
              museum?.customizations?.museumInfoBgColor
                ? museum?.customizations?.museumInfoBgColor
                : "#303030"
            }
          />
          <div
            style={{
              width: "100%",
              height: "70px",
            }}
          />
          <div
            className={styles.contentContainer}
            style={{ height: windowSize.innerWidth > 800 ? "100%" : "" }}
          >
            <div
              style={{
                backgroundColor: museum?.colore || "#303030",
              }}
              className="museo_info_container"
            >
              <LeftSideMuseumInfoTickets museum={museum} />
            </div>
            <div
              className="event_list_container"
              style={{ backgroundColor: museum?.colore || "white" }}
            >
              {!isEvents && !isTickets && windowSize.innerWidth > 800 && (
                <Tabs
                  variant="fullWidth"
                  value={tabIndex}
                  TabIndicatorProps={{ style: { background: museum?.colore } }}
                  onChange={(event, newValue) => {
                    setTabIndex(newValue);
                  }}
                  style={{ backgroundColor: "white" }}
                >
                  <Tab label={t("tickets")} />
                  <Tab label={t("events")} />
                </Tabs>
              )}
              {selected(tabIndex)}
            </div>
          </div>
          {!isEvents && !isTickets && windowSize.innerWidth <= 800 && (
            <Tabs
              variant="fullWidth"
              value={tabIndex}
              TabIndicatorProps={{ style: { background: museum?.colore } }}
              onChange={(event, newValue) => {
                setTabIndex(newValue);
              }}
              style={{
                backgroundColor: "white",
                position: "fixed",
                bottom: !!(cartCounter && cartCounter > 0) ? "60px" : "0",
                right: "0",
                left: "0",
              }}
            >
              <Tab label={t("tickets")} />
              <Tab label={t("events")} />
            </Tabs>
          )}
        </div>
      </MobileWrapper>
    </div>
  );
}

BaseEventList.propTypes = {
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string,
  }).isRequired,
  articles: PropTypes.arrayOf(PropTypes.object).isRequired,
  events: PropTypes.arrayOf(PropTypes.object).isRequired,
  shippingInfo: PropTypes.shape({
    type: PropTypes.string,
    timetable: PropTypes.object,
  }).isRequired,
  updateShippingInfo: PropTypes.func.isRequired,
  updateCartParams: PropTypes.func.isRequired,
  cartParams: PropTypes.shape({
    totalPrice: PropTypes.number,
    deliveryCost: PropTypes.number,
    servicesFees: PropTypes.number,
    total: PropTypes.number,
    cartCounter: PropTypes.number,
    totToShow: PropTypes.number,
    vat: PropTypes.number,
  }).isRequired,
  updateCart: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  cart: PropTypes.arrayOf(PropTypes.object),
  museum: PropTypes.object,
  customStyle: PropTypes.object,
  eventSelected: PropTypes.object,
  updateEventSelected: PropTypes.func,
};

BaseEventList.defaultProps = {
  museum: null,
  customStyle: {},
  eventSelected: null,
};
